import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import DynamicFormModal from "../../Modal/DynamicFormModal/DynamicFormModal";
import FilterGroupCard from "../../Reusables/FilterGroupCard/FilterGroupCard";
import {
    filterFields,
    filterGroupFields
} from "../../../helpers/InputFields/InputFields";
import { useDispatch, useSelector } from "react-redux";
import {
    addFilterGroupAction,
    addFilterAction,
    fetchAllFilters
} from "../../../utils/redux/filter/filterActions";

const FilterListingPage = () => {
    const dispatch = useDispatch();
    const filters = useSelector(state => state.filter.filters);

    const [modalConfig, setModalConfig] = useState({
        show: false,
        title: "",
        fields: [],
        initialData: {},
        onSubmit: null
    });

    /* ================= FETCH FILTER GROUPS ================= */

    useEffect(() => {
        dispatch(fetchAllFilters());
    }, [dispatch]);

    /* ================= MODAL OPENERS ================= */

    const openAddFilterGroupModal = () => {
        setModalConfig({
            show: true,
            title: "Add Filter Group",
            fields: filterGroupFields,
            initialData: {},
            onSubmit: async (data) => {
                await dispatch(addFilterGroupAction(data));
            }
        });
    };

    const openAddFilterModal = (filterGroupId) => {
        setModalConfig({
            show: true,
            title: "Add Filter",
            fields: filterFields,
            initialData: {},
            onSubmit: async (data) => {
                await dispatch(addFilterAction(filterGroupId, data));
            }
        });
    };

    return (
        <>
            <div className="d-flex flex-column align-items-center">
                <div className="d-flex my-4 w-100 justify-content-between">
                    <h3>Filters</h3>
                    <button
                        className="btn btn-primary"
                        onClick={openAddFilterGroupModal}
                    >
                        + Add Filter Type
                    </button>
                </div>

                <Accordion className="w-100" defaultActiveKey={0}>
                    {filters && filters?.length ? filters?.map((filterGroup, index) => (
                        <FilterGroupCard
                            key={filterGroup._id}
                            index={index}
                            filter={filterGroup}
                            onAddFilter={() =>
                                openAddFilterModal(filterGroup._id)
                            }
                        />
                    )) : <>No Filters Available</>}
                </Accordion>
            </div>

            <DynamicFormModal
                show={modalConfig.show}
                title={modalConfig.title}
                fields={modalConfig.fields}
                initialData={modalConfig.initialData}
                onSubmit={modalConfig.onSubmit}
                uploadOptions={{
                    module: "filter"
                }}
                onHide={() =>
                    setModalConfig(prev => ({ ...prev, show: false }))
                }
            />
        </>
    );
};

export default FilterListingPage;
